"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lineChart_1 = require("../line-chart/lineChart");
exports.AverageMaximumChart = function (props) {
    var sortedData = props.data.sort(function (a) {
        return a.name === "Maximum" ? 1 : -1;
    });
    return (react_1.default.createElement(lineChart_1.LineChart, { heading: props.heading, id: props.id, data: sortedData, metric: "time", lineStyles: [
            { stroke: "#0085c7", fill: "#0085c7" },
            { stroke: "#acdef8", fill: "#acdef8" },
        ], info: props.info, displayRange: props.displayRange, language: props.language, timezone: props.timezone }));
};
